import React from "react";

const LazyMeetingOneDriveSync = React.lazy(() =>
  import("./MeetingOneDriveSync").then((module) => ({ default: module.MeetingOneDriveSync }))
);

export default LazyMeetingOneDriveSync;
